import * as React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// import PdfDefault from './../../pdf/comerciales.pdf';
import Accordion from 'react-bootstrap/Accordion';
import styled from 'styled-components';

const VisorPdf = (props) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <Acordeon>
            <Accordion.Item activeKey={props.activo ? "0" : null}>
                <Accordion.Header>
                    {   props.temario ?
                            <h7>Temario </h7>:
                            <h7>Anexo</h7>

                    }
                   </Accordion.Header>
                <Accordion.Body>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.js">
                        <div
                            style={{
                                height: '750px',
                                width: '900px',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                        >
                            <Viewer
                                fileUrl={props.pdfEntrada}
                                plugins={[defaultLayoutPluginInstance]}
                            />
                        </div>
                    </Worker>
                </Accordion.Body>
            </Accordion.Item>
        </Acordeon>
    );
};

const Acordeon = styled(Accordion)`
    margin: 5% 0% 5% 0%;
    .accordion-button:focus {
    border-color: rgb(238, 128, 93) !important;
    box-shadow: none !important;
    
}

.accordion-button:not(.collapsed) {
    color: white !important;
    background-color: rgb(238, 128, 93) !important;
    box-shadow: rgb(238, 128, 93) !important;
}


`

export default VisorPdf;